import { createOsAuth } from '@os/auth-client';
import { loadEnv, viteOsEnv } from '@os/app-sdk';

/** Vite env validated once at boot (CONVENTIONS §10): VITE_OS_ISSUER, VITE_OS_CLIENT_ID (core/web/.env.example). */
const env = loadEnv(viteOsEnv, { source: import.meta.env as Record<string, string | undefined> });

export const ISSUER = env.VITE_OS_ISSUER.replace(/\/$/, '');
export const auth = createOsAuth({ issuer: ISSUER, clientId: env.VITE_OS_CLIENT_ID, devBypass: env.VITE_AUTH_DEV === 'true' });
